import apiClient from '../utils/apiClient';

/**
 * Cash voucher API helpers
 * Theo tài liệu CASHIER_MANAGEMENT_GUIDE.md
 */
export const cashVoucherAPI = {
  /**
   * Lấy danh sách phiếu chi
   */
  getCashVouchers: async (params = {}) => {
    return await apiClient.get({
      url: '/cash-vouchers',
      params,
    });
  },

  /**
   * Lấy chi tiết phiếu chi
   */
  getCashVoucherById: async (id) => {
    return await apiClient.get({
      url: `/cash-vouchers/${id}`,
    });
  },

  /**
   * Tạo phiếu chi mới
   */
  createCashVoucher: async (data) => {
    return await apiClient.post({
      url: '/cash-vouchers',
      data,
    });
  },

  /**
   * Duyệt phiếu chi
   */
  approveCashVoucher: async (id, currentUserId) => {
    return await apiClient.post({
      url: `/cash-vouchers/${id}/approve`,
      data: { current_user_id: currentUserId },
    });
  },

  /**
   * Từ chối phiếu chi
   */
  rejectCashVoucher: async (id, currentUserId, rejectedReason) => {
    return await apiClient.post({
      url: `/cash-vouchers/${id}/reject`,
      data: {
        current_user_id: currentUserId,
        rejected_reason: rejectedReason,
      },
    });
  },

  /**
   * Xóa phiếu chi
   */
  deleteCashVoucher: async (id, currentUserId) => {
    return await apiClient.delete({
      url: `/cash-vouchers/${id}`,
      data: { current_user_id: currentUserId },
    });
  },

  /**
   * #164550 — xem trước hệ quả huỷ phiếu (hoàn tiền két hay không, chứng từ nào bị gỡ).
   * Danh tính người huỷ do máy chủ lấy từ phiên đăng nhập, không gửi kèm.
   */
  getVoucherCancelPreview: async (id) => {
    return await apiClient.get({
      url: `/cash-vouchers/${id}/cancel-preview`,
    });
  },

  /**
   * #164550 — huỷ phiếu chi ĐÃ DUYỆT (chỉ Admin). Lý do bắt buộc.
   */
  cancelCashVoucher: async (id, reason) => {
    return await apiClient.post({
      url: `/cash-vouchers/${id}/cancel`,
      data: { reason },
    });
  },

  /**
   * Thống kê phiếu chi
   */
  getCashVoucherStats: async (params = {}) => {
    return await apiClient.get({
      url: '/cash-vouchers/statistics',
      params,
    });
  },

  /**
   * #110729 — danh sách KHOẢN LỆCH còn chưa giải trình để lập phiếu chi lùi ca.
   */
  getBackdatedVariances: async (branchId) => {
    return await apiClient.get({
      url: '/cash-vouchers/backdated-variances',
      params: { branch_id: branchId },
    });
  },

  /**
   * #110729 — tạo phiếu chi lùi ca (chỉ Admin; không trừ két). Danh tính người tạo do máy chủ
   * lấy từ phiên đăng nhập.
   */
  createBackdatedVoucher: async (data) => {
    return await apiClient.post({
      url: '/cash-vouchers/backdated',
      data,
    });
  },
};


